const translations = {
    NL: {
        // Common UI elements
        'search': 'Zoeken',
        'save': 'Opslaan',
        'cancel': 'Annuleren',
        'delete': 'Verwijderen',
        'confirm': 'Bevestigen',
        'yes': 'Ja',
        'no': 'Nee',
        'loading': 'Laden...',
        'back': 'Terug',
        'edit': 'Bewerken',
        'create': 'Aanmaken',
        'update': 'Bijwerken',
        'select': 'Selecteren',
        'remove': 'Verwijderen',
        'duplicate': 'Dupliceren',
        'or': 'OF',

        // Forms
        'name': 'Naam',
        'email': 'E-mail',
        'description': 'Beschrijving',
        'name_required': 'Naam is vereist.',
        'email_required': 'E-mail is vereist.',
        'code_required': 'Code is vereist.',
        'short_description_required': 'Korte beschrijving is vereist.',

        // Projects
        'projects': 'Projecten',
        'new_project': 'Nieuw project',
        'no_projects_found': 'Geen projecten gevonden',
        'project_admin': 'Project admin',
        'super_admin': 'Super admin',
        'confirm_delete_project': 'Weet je zeker dat je het geselecteerde project wilt verwijderen?',

        // Users
        'users': 'gebruikers',
        'first_name': 'Voornaam',
        'last_name': 'Achternaam',
        'language': 'Taal',
        'no_users_found': 'Geen gebruikers gevonden',
        'create_new_user': 'Nieuwe gebruiker aanmaken',
        'add_new_user': 'Nieuwe gebruiker toevoegen',
        'select_user': 'Selecteer een gebruiker',
        'user': 'gebruiker',
        'first_name_required': 'Voornaam is vereist.',
        'last_name_required': 'Achternaam is vereist.',
        'select_language': 'Selecteer taal',
        'currently_assigned_to': 'Momenteel toegewezen aan:',
        'assigned_to': 'Toegewezen aan:',
        'send_position_update': 'Stuur een positie-update naar',
        'this_user': 'deze gebruiker',
        'these_users': 'deze gebruikers',
        'confirm_remove_users': 'Weet je zeker dat je de geselecteerde gebruikers uit dit project wilt verwijderen?',
        'delete_users_permanently': 'Gebruikers permanent verwijderen',

        // Roles
        'roles': 'Rollen',
        'role': 'Rol',
        'new_role': 'Nieuwe rol',
        'no_roles_found': 'Geen rollen gevonden',
        'role_details': 'Rol details',
        'new_category_role': 'Nieuwe categorie rol',
        'edit_category_role': 'Categorie rol bewerken',
        'confirm_delete_roles': 'Weet je zeker dat je de geselecteerde rollen wilt verwijderen?',
        'new_agreement': 'Nieuwe overeenkomst',
        'role_description': 'Beschrijving van je rol',
        'old_user': 'Oude gebruiker',
        'new_user': 'Nieuwe gebruiker',
        'no_one': 'Niemand',
        'role_history': 'Rol geschiedenis',
        'role_updated_message': 'Deze rol is bijgewerkt. Maak een nieuwe overeenkomst aan.',
        'agreement_removed': 'Deze overeenkomst is verwijderd.',
        'pdf_creating': 'PDF bestand wordt aangemaakt...',
        'do_not_close': 'Sluit dit venster niet.',
        'no_item_found': 'Geen item gevonden',
        'signature_of': 'Handtekening van',
        'signature_description': 'Handtekening voor kennisname en akkoord met de functie die zal worden toegewezen na het doorlopen van je intern beoordelingsdossier.',
        'clear': 'Wissen',
        'apply': 'Toepassen',
        'filter': 'Filter',
        'exclude_empty_values': 'Lege waarden uitsluiten',
        'select_values': 'Selecteer waarden',
        'no_values_available': 'Geen waarden beschikbaar',
        'hide_section': 'Sectie verbergen',
        'hide_empty_values': 'Lege waarden verbergen',
        'show_empty_values': 'Lege waarden tonen',
        'confirm_remove_user': 'Weet je zeker dat je wilt verwijderen',
        'for_this_role': 'voor deze rol?',

        // Sections
        'sections': 'Secties',
        'all_sections': 'Alle secties',
        'all': 'Alle',
        'rows_per_page': 'Rijen per pagina',
        'no_sections_found': 'Geen secties gevonden',
        'new_section': 'Nieuwe sectie',
        'width': 'Breedte',
        'width_pixels': 'Breedte (pixels)',
        'show_in_table': 'Tonen in tabel',
        'show_in_description': 'Tonen in beschrijving',
        'is_hyperlink': 'Is een hyperlink',
        'confirm_delete_sections': 'Weet je zeker dat je de geselecteerde secties wilt verwijderen?',

        // RACI Codes
        'raci_codes': 'RACI codes',
        'code': 'Code',
        'color': 'Kleur',
        'short_description': 'Korte beschrijving',
        'long_description': 'Lange beschrijving',
        'no_raci_codes_found': 'Geen RACI codes gevonden',
        'new_raci_code': 'Nieuwe RACI code',
        'edit_raci_code': 'RACI code bewerken',
        'confirm_delete_codes': 'Weet je zeker dat je de geselecteerde codes wilt verwijderen?',

        // Tasks
        'add_new_task': 'Nieuwe taak toevoegen',
        'create_new_task_below': 'Nieuwe taak hieronder aanmaken',
        'no_tasks': 'Geen taken',
        'confirm_delete_task': 'Weet je zeker dat je deze taak wilt verwijderen?',
        'to_complete': 'Aan te vullen...',

        // Tooltips and status
        'resend_agreement': 'Opnieuw versturen',
        'resend_done': 'Overeenkomst opnieuw verstuurd',
        'resend_failed': 'Opnieuw versturen mislukt',
        'forms_instance': 'Forms-instantie',
        'awaiting_signature': 'Wacht op ondertekening',
        'no_user_assigned': 'Geen gebruiker toegewezen',
        'role_updated_new_agreement': 'Rol bijgewerkt. Nieuwe overeenkomst moet worden verstuurd',
        'no_one_assigned': 'Niemand is toegewezen',

        // Columns and display
        'show_hidden_columns': 'Verborgen kolommen tonen',
        'show_column': 'Kolom tonen',
        'hidden_columns': 'Verborgen kolommen',
        'no_hidden_columns': 'Geen verborgen kolommen',

        // Navigation
        'logout': 'Uitloggen',
        'tasks': 'taken',
        'settings': 'instellingen',
        'projects_list': 'Projectenlijst',

        // Versions
        'version': 'Versie',
        'name_number': 'Naam + nummer',
        'new_version': 'Nieuwe versie',
        'confirm_delete_version': 'Weet je zeker dat je versie nummer',
        'save_failed': 'Opslaan is mislukt. Probeer het opnieuw.',

        // Agreements
        'send_agreements': 'Overeenkomsten versturen',
        'export_csv': 'Exporteren naar CSV',
        'roles_updated_message': 'De volgende rollen zijn bijgewerkt.<br /> Wil je een nieuwe overeenkomst naar deze gebruikers sturen?',
        'send': 'Versturen',
        'project_needs_sections_roles': 'Dit project heeft secties en rollen nodig.',
        'setup': 'Instellen',

        // Reports (PIPE-321)
        'users_per_project_monthly': 'Gebruikers per project per maand',
        'users_per_project_monthly_subtitle': 'Cumulatief aantal gebruikers per project, aan het einde van elk van de laatste 24 maanden.',
        'users_per_project_monthly_limitation': 'Opmerking: aangezien projectlidmaatschap niet gedateerd is in de database, gebruiken deze cijfers de huidige lidmaatschappen die worden teruggeprojecteerd vanaf de aanmaakdatum van het account van elke gebruiker — een gebruiker die onlangs bij een project is gekomen maar wiens account ouder is, telt dus al mee sinds die eerdere datum.',
        'project': 'Project',
        'month': 'Maand',
        'total': 'Totaal',

        // Legacy support
        'Name': 'Naam',
        'Width (pixels)': 'Breedte (pixels)',
        'Show in table': 'Tonen in tabel',
        'Show in description': 'Tonen in beschrijving',
        'Is a hyperlink': 'Is een hyperlink',
        'First name': 'Voornaam',
        'Last name': 'Achternaam',
        'Email': 'E-mail',
        'Language': 'Taal',
        'Project admin': 'Project beheerder',
        'Super admin': 'Super beheerder',
        'Search': 'Zoeken',
        'Cancel': 'Annuleren',
        'Save': 'Opslaan',
        'Delete': 'Verwijderen',
        'Edit': 'Bewerken',
        'Create': 'Aanmaken',
        'Update': 'Bijwerken',
        'Select': 'Selecteren',
        'Confirm': 'Bevestigen',
        'Yes': 'Ja',
        'No': 'Nee',
        'No sections found': 'Geen secties gevonden',
        'No users found': 'Geen gebruikers gevonden',
        'Are you sure you want to delete the selected sections?': 'Weet je zeker dat je de geselecteerde secties wilt verwijderen?',
        'Name is required.': 'Naam is verplicht.',
        'New section': 'Nieuwe sectie',
        'Create a user': 'Gebruiker aanmaken',
        'Update a user': 'Gebruiker bijwerken',
        'Select a user': 'Gebruiker selecteren'
    },
    FR: {
        // Common UI elements
        'search': 'Rechercher',
        'save': 'Enregistrer',
        'cancel': 'Annuler',
        'delete': 'Supprimer',
        'confirm': 'Confirmer',
        'yes': 'Oui',
        'no': 'Non',
        'loading': 'Chargement...',
        'back': 'Retour',
        'edit': 'Modifier',
        'create': 'Créer',
        'update': 'Mettre à jour',
        'select': 'Sélectionner',
        'remove': 'Supprimer',
        'duplicate': 'Dupliquer',
        'or': 'OU',

        // Forms
        'name': 'Nom',
        'email': 'E-mail',
        'description': 'Description',
        'name_required': 'Le nom est requis.',
        'email_required': 'L\'e-mail est requis.',
        'code_required': 'Le code est requis.',
        'short_description_required': 'La description courte est requise.',

        // Projects
        'projects': 'Projets',
        'new_project': 'Nouveau projet',
        'no_projects_found': 'Aucun projet trouvé',
        'project_admin': 'Administrateur du projet',
        'super_admin': 'Super administrateur',
        'confirm_delete_project': 'Êtes-vous sûr de vouloir supprimer le projet sélectionné ?',

        // Users
        'users': 'utilisateurs',
        'first_name': 'Prénom',
        'last_name': 'Nom de famille',
        'language': 'Langue',
        'no_users_found': 'Aucun utilisateur trouvé',
        'create_new_user': 'Créer un nouvel utilisateur',
        'add_new_user': 'Ajouter un nouvel utilisateur',
        'select_user': 'Sélectionner un utilisateur',
        'user': 'utilisateur',
        'first_name_required': 'Le prénom est requis.',
        'last_name_required': 'Le nom de famille est requis.',
        'select_language': 'Sélectionner la langue',
        'confirm_remove_users': 'Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés de ce projet ?',

        // Sections
        'sections': 'Sections',
        'all_sections': 'Toutes les sections',
        'all': 'Tout',
        'rows_per_page': 'Lignes par page',
        'new_section': 'Nouvelle section',
        'no_sections_found': 'Aucune section trouvée',
        'width': 'Largeur',
        'width_pixels': 'Largeur (pixels)',
        'show_in_table': 'Afficher dans le tableau',
        'show_in_description': 'Afficher dans la description',
        'is_hyperlink': 'Est un hyperlien',
        'confirm_delete_sections': 'Êtes-vous sûr de vouloir supprimer les sections sélectionnées ?',

        // Roles
        'roles': 'Rôles',
        'role': 'Rôle',
        'new_role': 'Nouveau rôle',
        'no_roles_found': 'Aucun rôle trouvé',
        'role_details': 'Détails du rôle',
        'new_category_role': 'Nouveau catégorie de rôle',
        'edit_category_role': 'Modifier le rôle de catégorie',
        'confirm_delete_roles': 'Êtes-vous sûr de vouloir supprimer les rôles sélectionnés ?',
        'new_agreement': 'Nouvel accord',
        'role_description': 'Description de votre rôle',
        'old_user': 'Ancien utilisateur',
        'new_user': 'Nouvel utilisateur',
        'no_one': 'Personne',
        'role_history': 'Historique du rôle',
        'role_updated_message': 'Ce rôle a été mis à jour. Veuillez créer un nouvel accord.',
        'agreement_removed': 'Cet accord a été supprimé.',
        'pdf_creating': 'Fichier PDF en cours de création...',
        'do_not_close': 'Ne fermez pas cette fenêtre.',
        'no_item_found': 'Aucun élément trouvé',
        'signature_of': 'Signature de',
        'signature_description': 'Signature pour reconnaissance et accord avec la fonction qui sera assignée après avoir parcouru votre dossier d\'évaluation interne.',
        'clear': 'Effacer',
        'apply': 'Appliquer',
        'filter': 'Filtre',
        'exclude_empty_values': 'Exclure les valeurs vides',
        'select_values': 'Sélectionner les valeurs',
        'no_values_available': 'Aucune valeur disponible',
        'hide_section': 'Masquer la section',
        'hide_empty_values': 'Masquer les valeurs vides',
        'show_empty_values': 'Afficher les valeurs vides',
        'confirm_remove_user': 'Êtes-vous sûr de vouloir supprimer',
        'for_this_role': 'pour ce rôle ?',
        'assigned_to': 'Assigné à:',
        'currently_assigned_to': 'Actuellement assigné à:',
        'delete_users_permanently': 'Supprimer définitivement les utilisateurs',
        'send_position_update': 'Envoyer une mise à jour de position à',
        'these_users': 'ces utilisateurs',
        'this_user': 'cet utilisateur',

        // RACI Codes
        'raci_codes': 'Codes RACI',
        'code': 'Code',
        'color': 'Couleur',
        'short_description': 'Description courte',
        'long_description': 'Description longue',
        'no_raci_codes_found': 'Aucun code RACI trouvé',
        'new_raci_code': 'Nouveau code RACI',
        'edit_raci_code': 'Modifier le code RACI',
        'confirm_delete_codes': 'Êtes-vous sûr de vouloir supprimer les codes sélectionnés ?',

        // Tasks
        'add_new_task': 'Ajouter une nouvelle tâche',
        'create_new_task_below': 'Créer une nouvelle tâche en dessous',
        'no_tasks': 'Aucune tâche',
        'confirm_delete_task': 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
        'to_complete': 'À compléter...',

        // Tooltips and status
        'resend_agreement': 'Renvoyer',
        'resend_done': 'Accord renvoyé',
        'resend_failed': 'Échec du renvoi',
        'forms_instance': 'Instance Forms',
        'awaiting_signature': 'En attente de signature',
        'no_user_assigned': 'Aucun utilisateur assigné',
        'role_updated_new_agreement': 'Rôle mis à jour. Nouvel accord doit être envoyé',
        'no_one_assigned': 'Personne n\'est assigné',

        // Columns and display
        'show_hidden_columns': 'Afficher les colonnes masquées',
        'show_column': 'Afficher la colonne',
        'hidden_columns': 'Colonnes masquées',
        'no_hidden_columns': 'Aucune colonne masquée',

        // Navigation
        'logout': 'Déconnexion',
        'tasks': 'tâches',
        'settings': 'paramètres',
        'projects_list': 'Liste des projets',

        // Versions
        'version': 'Version',
        'name_number': 'Nom + numéro',
        'new_version': 'Nouvelle version',
        'confirm_delete_version': 'Êtes-vous sûr de vouloir supprimer la version numéro',
        'save_failed': 'Échec de l\'enregistrement. Veuillez réessayer.',

        // Agreements
        'send_agreements': 'Envoyer les accords',
        'export_csv': 'Exporter en CSV',
        'roles_updated_message': 'Les rôles suivants ont été mis à jour.<br /> Voulez-vous envoyer un nouvel accord à ces utilisateurs ?',
        'send': 'Envoyer',
        'project_needs_sections_roles': 'Ce projet a besoin de sections et de rôles.',
        'setup': 'Configuration',

        // Reports (PIPE-321)
        'users_per_project_monthly': 'Utilisateurs par projet par mois',
        'users_per_project_monthly_subtitle': 'Nombre cumulé d\'utilisateurs par projet, à la fin de chacun des 24 derniers mois.',
        'users_per_project_monthly_limitation': 'Remarque : l\'appartenance à un projet n\'étant pas datée dans la base, ces chiffres utilisent les appartenances actuelles projetées en arrière à partir de la date de création du compte de chaque utilisateur — un utilisateur ayant rejoint un projet récemment mais dont le compte est plus ancien sera donc compté comme membre de ce projet depuis cette date antérieure.',
        'project': 'Projet',
        'month': 'Mois',
        'total': 'Total',

        // Legacy support
        'Name': 'Nom',
        'Width (pixels)': 'Largeur (pixels)',
        'Show in table': 'Afficher dans le tableau',
        'Show in description': 'Afficher dans la description',
        'Is a hyperlink': 'Est un hyperlien',
        'First name': 'Prénom',
        'Last name': 'Nom de famille',
        'Email': 'E-mail',
        'Language': 'Langue',
        'Project admin': 'Administrateur du projet',
        'Super admin': 'Super administrateur',
        'Search': 'Rechercher',
        'Cancel': 'Annuler',
        'Save': 'Enregistrer',
        'Delete': 'Supprimer',
        'Edit': 'Modifier',
        'Create': 'Créer',
        'Update': 'Mettre à jour',
        'Select': 'Sélectionner',
        'Confirm': 'Confirmer',
        'Yes': 'Oui',
        'No': 'Non',
        'No sections found': 'Aucune section trouvée',
        'No users found': 'Aucun utilisateur trouvé',
        'Are you sure you want to delete the selected sections?': 'Êtes-vous sûr de vouloir supprimer les sections sélectionnées ?',
        'Name is required.': 'Le nom est requis.',
        'New section': 'Nouvelle section',
        'Create a user': 'Créer un utilisateur',
        'Update a user': 'Mettre à jour un utilisateur',
        'Select a user': 'Sélectionner un utilisateur'
    },
    EN: {
        // Common UI elements
        'search': 'Search',
        'save': 'Save',
        'cancel': 'Cancel',
        'delete': 'Delete',
        'confirm': 'Confirm',
        'yes': 'Yes',
        'no': 'No',
        'loading': 'Loading...',
        'back': 'Back',
        'edit': 'Edit',
        'create': 'Create',
        'update': 'Update',
        'select': 'Select',
        'remove': 'Remove',
        'duplicate': 'Duplicate',
        'or': 'OR',

        // Forms
        'name': 'Name',
        'email': 'Email',
        'description': 'Description',
        'name_required': 'Name is required.',
        'email_required': 'Email is required.',
        'code_required': 'Code is required.',
        'short_description_required': 'Short description is required.',

        // Projects
        'projects': 'Projects',
        'new_project': 'New project',
        'no_projects_found': 'No projects found',
        'project_admin': 'Project admin',
        'super_admin': 'Super admin',
        'confirm_delete_project': 'Are you sure you want to delete the selected project?',

        // Users
        'users': 'users',
        'first_name': 'First name',
        'last_name': 'Last name',
        'language': 'Language',
        'no_users_found': 'No users found',
        'create_new_user': 'Create new user',
        'add_new_user': 'Add new user',
        'select_user': 'Select user',
        'user': 'user',
        'first_name_required': 'First name is required.',
        'last_name_required': 'Last name is required.',
        'select_language': 'Select language',
        'confirm_remove_users': 'Are you sure you want to remove the selected users from this project?',

        // Sections
        'sections': 'Sections',
        'all_sections': 'All sections',
        'all': 'All',
        'rows_per_page': 'Rows per page',
        'new_section': 'New section',
        'no_sections_found': 'No sections found',
        'width': 'Width',
        'width_pixels': 'Width (pixels)',
        'show_in_table': 'Show in table',
        'show_in_description': 'Show in description',
        'is_hyperlink': 'Is hyperlink',
        'confirm_delete_sections': 'Are you sure you want to delete the selected sections?',

        // Roles
        'roles': 'Roles',
        'role': 'Role',
        'new_role': 'New role',
        'no_roles_found': 'No roles found',
        'role_details': 'Role details',
        'new_category_role': 'New category role',
        'edit_category_role': 'Edit category role',
        'confirm_delete_roles': 'Are you sure you want to delete the selected roles?',
        'new_agreement': 'New agreement',
        'role_description': 'Description of your role',
        'old_user': 'Old user',
        'new_user': 'New user',
        'no_one': 'No one',
        'role_history': 'Role history',
        'role_updated_message': 'This role has been updated. Please create a new agreement.',
        'agreement_removed': 'This agreement has been removed.',
        'pdf_creating': 'PDF file is being created...',
        'do_not_close': 'Do not close this window.',
        'no_item_found': 'No item found',
        'signature_of': 'Signature of',
        'signature_description': 'Signature for acknowledgment and agreement with the role that will be assigned after going through your internal evaluation file.',
        'clear': 'Clear',
        'apply': 'Apply',
        'filter': 'Filter',
        'exclude_empty_values': 'Exclude empty values',
        'select_values': 'Select values',
        'no_values_available': 'No values available',
        'hide_section': 'Hide section',
        'hide_empty_values': 'Hide empty values',
        'show_empty_values': 'Show empty values',
        'confirm_remove_user': 'Are you sure you want to remove',
        'for_this_role': 'for this role?',
        'assigned_to': 'Assigned to:',
        'currently_assigned_to': 'Currently assigned to:',
        'delete_users_permanently': 'Delete users permanently',
        'send_position_update': 'Send position update to',
        'these_users': 'these users',
        'this_user': 'this user',

        // RACI Codes
        'raci_codes': 'RACI Codes',
        'code': 'Code',
        'color': 'Color',
        'short_description': 'Short description',
        'long_description': 'Long description',
        'no_raci_codes_found': 'No RACI codes found',
        'new_raci_code': 'New RACI code',
        'edit_raci_code': 'Edit RACI code',
        'confirm_delete_codes': 'Are you sure you want to delete the selected codes?',

        // Tasks
        'add_new_task': 'Add new task',
        'create_new_task_below': 'Create new task below',
        'no_tasks': 'No tasks',
        'confirm_delete_task': 'Are you sure you want to delete this task?',
        'to_complete': 'To complete...',

        // Tooltips and status
        'resend_agreement': 'Resend',
        'resend_done': 'Agreement sent again',
        'resend_failed': 'Resend failed',
        'forms_instance': 'Forms instance',
        'awaiting_signature': 'Awaiting signature',
        'no_user_assigned': 'No user assigned',
        'role_updated_new_agreement': 'Role updated. New agreement must be sent',
        'no_one_assigned': 'No one is assigned',

        // Columns and display
        'show_hidden_columns': 'Show hidden columns',
        'show_column': 'Show column',
        'hidden_columns': 'Hidden columns',
        'no_hidden_columns': 'No hidden columns',

        // Navigation
        'logout': 'Logout',
        'tasks': 'tasks',
        'settings': 'settings',
        'projects_list': 'Projects list',

        // Versions
        'version': 'Version',
        'name_number': 'Name + number',
        'new_version': 'New version',
        'confirm_delete_version': 'Are you sure you want to delete version number',
        'save_failed': 'Save failed. Please try again.',

        // Agreements
        'send_agreements': 'Send agreements',
        'export_csv': 'Export CSV',
        'roles_updated_message': 'The following roles have been updated.<br /> Do you want to send a new agreement to these users?',
        'send': 'Send',
        'project_needs_sections_roles': 'This project needs sections and roles.',
        'setup': 'Setup',

        // Reports (PIPE-321)
        'users_per_project_monthly': 'Users per project per month',
        'users_per_project_monthly_subtitle': 'Cumulative number of users per project, at the end of each of the last 24 months.',
        'users_per_project_monthly_limitation': "Note: since project membership isn't dated in the database, these figures use today's memberships projected backwards from each user's account creation date — so a user who joined a project recently but created their account earlier will count as a member of that project since that earlier date.",
        'project': 'Project',
        'month': 'Month',
        'total': 'Total',

        // Legacy support
        'Name': 'Name',
        'Width (pixels)': 'Width (pixels)',
        'Show in table': 'Show in table',
        'Show in description': 'Show in description',
        'Is a hyperlink': 'Is a hyperlink',
        'First name': 'First name',
        'Last name': 'Last name',
        'Email': 'Email',
        'Language': 'Language',
        'Project admin': 'Project admin',
        'Super admin': 'Super admin',
        'Search': 'Search',
        'Cancel': 'Cancel',
        'Save': 'Save',
        'Delete': 'Delete',
        'Edit': 'Edit',
        'Create': 'Create',
        'Update': 'Update',
        'Select': 'Select',
        'Confirm': 'Confirm',
        'Yes': 'Yes',
        'No': 'No',
        'No sections found': 'No sections found',
        'No users found': 'No users found',
        'Are you sure you want to delete the selected sections?': 'Are you sure you want to delete the selected sections?',
        'Name is required.': 'Name is required.',
        'New section': 'New section',
        'Create a user': 'Create a user',
        'Update a user': 'Update a user',
        'Select a user': 'Select a user'
    }
};

export const useTranslations = () => {
    const currentLanguage = ref('NL');

    // Listen for language changes (only setup the listener, cleanup will be manual)
    if (import.meta.client) {
        const handleLanguageChange = (event) => {
            currentLanguage.value = event.detail;
        };

        document.addEventListener('language-changed', handleLanguageChange);
    }

    const t = (key) => {
        const lang = currentLanguage.value;
        return translations[lang]?.[key] || translations['EN']?.[key] || key;
    };

    return {
        t,
        currentLanguage: readonly(currentLanguage),
        translations
    };
};
